import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {RecorderService} from '../../services/recorder/recorder.service';
import {UploadService} from '../../services/upload.service';

const CONSTRAINS = {
  video: {
    width: {
      ideal: 640
    },
    height: {
      ideal: 480
    },
    frameRate: {
      ideal: 30
    }
  },
  audio: false
};

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['../../app.component.scss', './video.component.scss']
})
export class VideoComponent implements OnInit, AfterViewInit, OnDestroy {
  public videoElement: any;
  public localStream: any;
  public errMsg: any;
  public cameraIsEnable: boolean;
  isBusy = false;
  downloadUrl: string;
  downloadCsvUrl: string;

  constructor(public recorderService: RecorderService, private uploadService: UploadService) {
  }

  ngOnInit(): void {
    this.videoElement = document.getElementById('localVideo') as HTMLVideoElement;
  }

  ngAfterViewInit(): void {
    this.startCamera();
  }

  ngOnDestroy(): void {
    this.stopCamera();
    this.recorderService.currentBlob = null;
    this.recorderService.currentUrl = null;
  }

  public startCamera(callback = null): void {
    console.log('start Video');
    this.errMsg = undefined;
    if (this.localStream) {
      this.stopCamera();
    }
    this.cameraIsEnable = false;
    navigator.mediaDevices.getUserMedia(CONSTRAINS)
      .then(stream => {
        this.localStream = stream;
        this.videoElement.srcObject = stream;
        this.videoElement.muted = true;
        this.cameraIsEnable = true;
        if (callback) {
          callback();
        }
      })
      .catch(error => {
        if (error) {
          console.log(error.message);
        }
        this.errMsg = 'Camera not found';
        console.log('catch mediaDevices.getUserMedia(CONSTRAINS)');
      });

    this.videoElement.addEventListener('loadedmetadata', function(): void {
      console.log('Local video videoWidth: ' + this.videoWidth + 'px,  videoHeight: ' + this.videoHeight + 'px');
    });
  }

  public stopCamera(): void {
    if (this.localStream) {
      const stop = () => {
        const tracks = this.localStream.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
        this.localStream = null;
      };
      if (this.recorderService.isRecorderActive) {
        this.recorderService.stopRecording(() => {
          stop();
        });
      } else {
        stop();
      }
    }
  }

  public startRecord(): void {
    if (this.recorderService.isRecorderActive) {
      this.recorderService.stopRecording();
    } else {
      this.recorderService.startRecording(this.localStream);
    }
  }

  public upload(): void {
    if (!this.isBusy) {
      this.isBusy = true;
      const file: File = new File([this.recorderService.currentBlob], 'video.webm', {
        type: 'video/webm'
      });
      const fd: FormData = new FormData();
      fd.append('file', file);
      this.uploadService.uploadMultiMedia(fd, (url: string, csvUrl: string) => {
        this.downloadUrl = url;
        this.downloadCsvUrl = csvUrl;
        this.isBusy = false;
      }, () => {
        this.isBusy = false;
      });
    }
  }

  download(): void {
    window.open(this.downloadUrl);
  }

  downloadCsv(): void {
    window.open(this.downloadCsvUrl);
  }

}
